<template>
  <div />
</template>

<script>
const acceptedKeys = ['e', 's', 'p', 'g', 'd'];

export default {
  mounted() {
    document.addEventListener('keydown', this.handleKey);
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKey);
  },

  methods: {
    handleKey(e) {
      if (e.key === 'Escape') {
        this.$bus.$emit('keyboard-shortcut-esc');
      } else if (e.key === 'Enter') {
        this.$bus.$emit('keyboard-shortcut-enter');
      } else if (e.ctrlKey || e.metaKey) {
        if (e.key && acceptedKeys.includes(e.key)) {
          e.preventDefault();
          this.$bus.$emit(`keyboard-shortcut-${e.key}`);
        }
      }
    },
  },
};
</script>
